export const HIGHLIGHT_ORDER_ROW_CLASS = 'highlightOrderRow'
export const HIGHLIGHT_ORDER_ROW_DURATION_MS = 2_000
export const HIGHLIGHT_ORDER_ROW_TIMEOUT_MS = 1_000
